import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';
import VueGtag from "vue-gtag";
import "../src/design/app.scss";

import store from '@/state/store'

import App from './App.vue'

import i18n from './i18n'

import tinymce from 'vue-tinymce-editor'

import api from '../src/services/axiosHeader' 
import VueCookies from 'vue-cookies';
import { loadAxeptio } from './components/axeptio';



Vue.use(VueGtag, {
    config: { id: "G-YT2GSMWWD5" }
  }, router);
  
Vue.use(VueCookies);
Vue.component('tinymce', tinymce)
Vue.use(VueRouter)
Vue.use(vco)
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
        libraries: 'places',
    },
    installComponents: true
})
Vue.component('apexchart', VueApexCharts)

//interceptors axios
Vue.prototype.$http = api;

// Global Function
Vue.mixin({
    methods: {
        dateFormat(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();
            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;
            return [year, month, day].join('-');
        },
        globalHelper() {
            alert(process.env.API_URL)
        },
        ValidatePhoneNumber(phone) {
            return /^(?:(?:\+|00)33[\s.-]{0,3}(?:\(0\)[\s.-]{0,3})?|0)[1-9](?:(?:[\s.-]?\d{2}){4}|\d{2}(?:[\s.-]?\d{3}){2})$/.test(phone);
        },
        truncateText(text, length, suffix) {
            if (text.length > length) {
                return text.substring(0, length) + suffix;
            } else {
                return text;
            }
        },
        // Format date
        formatDate(str) {
            let d = new Date(str);
            let ye = new Intl.DateTimeFormat("fr", {year: "numeric"}).format(d);
            let mo = new Intl.DateTimeFormat("fr", {month: "short"}).format(d);
            let da = new Intl.DateTimeFormat("fr", {day: "2-digit"}).format(d);
            return `${da} ${mo} ${ye}`;
        },
        // Create an absolute path for image
        pathImage(name) {
            return this.baseURL + "/uploads/images/" + name;
        },
        // Capitalize First Letter
        capitalizeFirstLetter(str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        },
        // (usage bien : s_usage_bien)
        useStatus(status) {
            switch (status) {
                case "25698157":
                    return "Activité professionnelle";
                case "25a94479":
                    return "Résidence secondaire";
                case "50b4e2fb":
                    return "Résidence locative";
                case "75f16352":
                    return "Défiscalisation";
                case "9a2bc3c3":
                    return "Résidence principale";
                case "autres":
                    return "Autres";
                default:
                    return "Aucune donnée";
            }
        },
        // (professional situation : s_situation_pro)
        professionalSituationStatus(status) {
            switch (status) {
                case "265f5fab":
                    return "Salarié cadre dans le secteur public";
                case "61d50277":
                    return "Commerçants et assimilés";
                case "71f792a2":
                    return "Sans activité professionnelle";
                case "7facad6e":
                    return "Salarié non cadre dans le secteur privé";
                case "8eb07de5":
                    return "Profession libérale";
                case "90b7243a":
                    return "Ouvrier contremaître agent de maitrise du secteur privé";
                case "agriculteurs_exploitants":
                    return "Agriculteurs exploitants";
                case "artisans":
                    return "Artisans";
                case "bcde4a23":
                    return "Salarié cadre dans le secteur privé";
                case "cac55a28":
                    return "Profession indépendante";
                case "cd713e38":
                    return "Sans emploi";
                case "e52db8e6":
                    return "Salarié non cadre dans le secteur public";
                case "chef_dentreprise":
                    return "Chef d'entreprise";
                case "d73ab6b8":
                    return "Retraité(e)";
                default:
                    return "Aucune donnée";
            }
        },
        // (demand type : s_type_bien)
        demandTypeStatus(status) {
            switch (status) {
                case "achat_fond_de_commerce":
                    return "Achat fond de commerce";
                case "appartement_ancien":
                    return "Appartement ancien";
                case "appartement_neuf_vefa":
                    return "Appartement neuf (VEFA)";
                case "b03b9af5":
                    return "Regroupement / restructuration de crédits";
                case "bureaux":
                    return "Bureaux";
                case "commerce":
                    return "Locaux commerciaux";
                case "maison_ancienne":
                    return "Maison ancienne";
                case "maison_neuve_ccmi":
                    return "Maison neuve (CCMI)";
                case "terrain_construction":
                    return "Terrain + construction";
                case "scpi":
                    return "SCPI";    
                default:
                    return "Aucune donnée";
            }
        },
        // ( : s_mode_achat)
        modeOfPurshaseStatus(status) {
            switch (status) {
                case "2326d790":
                    return "Société commerciale";
                case "achat_personnel_en_direct":
                    return "Achat personnel en direct";
                case "autres":
                    return "Autres";
                case "cd7dbc1d":
                    return "Nue-propriété";
                case "sci":
                    return "SCI";
                case "usufruit":
                    return "Usufruit";
                default:
                    return "Aucune donnée";
            }
        },
        // ( : s_modalite_achat.)
        purshaseMethodStatus(status) {
            switch (status) {
                case "achat_avec_un_co_emprunteur":
                    return "Achat avec un co-emprunteur";
                case "achat_seul":
                    return "Achat seul";
                default:
                    return "Aucune donnée";
            }
        },
        // s_duree_credit_souhait
        creditsStatus(status) {
            switch (status) {
                case "10_ans":
                    return "10 ans";
                case "15_ans":
                    return "15 ans";
                case "20_ans":
                    return "20 ans";
                case "25_ans":
                    return "25 ans";
                case "30_ans":
                    return "30 ans";
                case "5_ans":
                    return "5 ans";
                default:
                    return "Aucune donnée";
            }
        },
        statusData(status, data) {
            const item = data.find((el) => el.id === status);
            return item;
        },

    },
})


  loadAxeptio().then(() => {
    window.axeptioSettings = {
      clientId: '668d01e475c5f2dcfcbb454d', // Replace with your actual client ID
      cookiesVersion: 'prexange.com-fr-EU' // Replace with your actual cookies version
    };
  
    window._axcb = window._axcb || [];
    window._axcb.push(() => {
      window.Axeptio.init(window.axeptioSettings);
    });
  }).catch((error) => {
    console.error('Axeptio script failed to load:', error);
  });
new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')